var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import MuiChip from "@mui/material/Chip";
import { baseChipStyles } from "./ChipV2.styles";
import Tooltip from "../Tooltip";
export var CHIP_VARIANT;
(function (CHIP_VARIANT) {
    CHIP_VARIANT["Primary"] = "primary";
    CHIP_VARIANT["Secondary"] = "secondary";
    CHIP_VARIANT["SecondaryOutline"] = "secondaryOutline";
})(CHIP_VARIANT || (CHIP_VARIANT = {}));
export var CHIP_SIZE;
(function (CHIP_SIZE) {
    CHIP_SIZE["Small"] = "small";
    CHIP_SIZE["Medium"] = "medium";
})(CHIP_SIZE || (CHIP_SIZE = {}));
// deleteicon requires fn
// eslint-disable-next-line @typescript-eslint/no-empty-function
var emptyFn = function () { };
var ChipV2 = function (_a, ref) {
    var selected = _a.selected, _b = _a.selectable, selectable = _b === void 0 ? true : _b, _c = _a.size, size = _c === void 0 ? CHIP_SIZE.Medium : _c, label = _a.label, _d = _a.deleteIcon, deleteIcon = _d === void 0 ? _jsx(CloseIcon, {}) : _d, onDelete = _a.onDelete, tooltip = _a.tooltip, dragged = _a.dragged, _e = _a.variant, variant = _e === void 0 ? CHIP_VARIANT.Primary : _e, sx = _a.sx, rest = __rest(_a, ["selected", "selectable", "size", "label", "deleteIcon", "onDelete", "tooltip", "dragged", "variant", "sx"]);
    // memoize styles
    var styles = useMemo(function () { return (__assign(__assign({}, baseChipStyles), sx)); }, [sx]);
    return (_jsx(MuiChip, __assign({ variant: variant, size: size, deleteIcon: tooltip ? (_jsx(Tooltip, __assign({ title: tooltip }, { children: _jsx(InfoOutlinedIcon, {}) }))) : (deleteIcon), onDelete: tooltip ? emptyFn : onDelete, label: label, className: selectable && selected
            ? "MuiChip-selected"
            : dragged
                ? "MuiChip-dragged"
                : "", ref: ref, "data-testid": "chip-".concat(label), sx: styles }, rest)));
};
export default forwardRef(ChipV2);
